import React from 'react';

import {displayTranslationsList} from '../../../auto/js/lists/metadata/TranslationsList'
import {whoami} from '../../../auto/js/users/UserInfo';
import { displayLocaleSheet } from '../../../auto/js/sheets/LocaleSheet';
import { displaySignatureRequestList } from '../../../auto/js/lists/signatureRequest/SignatureRequestList';
import { displayNewSignatureRequestForm, displayReadSignatureRequestForm } from '../../../auto/js/forms/signatureRequest/NewSignatureRequestForm';
import IncommingSignature from '../Widgets/IncomingRequests';
import MySignature from '../Widgets/MyRequests';
import { displayRibbon } from '../../../auto/js/pages/WelcomePage';
import { loadIncommingRequestsDashboard, loadMyRequestsDashboard } from '../utils';
import { setCompletedContext, setNewContext, setPendingContext } from '../lists/signatureRequest/SignatureRequestListCommon';
import { STATUS_PENDING } from '../../../auto/js/metadata/Status';

export const menu = () => {
    return {
        /* "signature-requests": {
            "requests": {
                submenu: {
                    "actions": {
                        options: {
                            new: {label: "New", do: (gui) => displayNewSignatureRequestForm(gui, () => displaySignatureRequestList(gui))},
                        },
                        label: "Actions"
                    }
                },
                label: "Signature Requests",
                do: (gui) => displaySignatureRequestList(gui)
            },
            label: "Signature Requests",
            description: "Check or create Signature Requests"
        },
        ...((whoami().roles.includes('ALL')|| whoami().roles.includes('MAINTENANCE')) && {
            "configurations": {
                "translations": {
                    submenu: {
                        "translations": {
                            options: {
                               
                            },
                        },
                    },
                    label: "Translations",
                    do: (gui) => displayTranslationsList(gui)
                },
                "locale-id": {
                    submenu: {
                        "locale-id": {
                            options: {
                                
                            },
                        },
                    },
                    label: "Languages",
                    do: (gui) => displayLocaleSheet(gui)
                },
                label: "Configuration",
                description: "Configure application metadatas and languages"
            },  
        })*/
        'my-requests': {
            label: 'My Signature Requests',
            content: (gui) => <MySignature new={() => { 
                let defaultOption = "new";   
                gui.goTo(displayRibbon(), requestMenu(defaultOption)); 
                }}
                loadData={async () => loadMyRequestsDashboard()}
                seeAll={() => {
                    let defaultFilter = {initiatorId: whoami().username}
                    gui.goTo(displayRibbon(), requestMenu(null, null, defaultFilter));     
                }}
                action={(request) => {
                    let defaultOption = "read"; 
                    gui.goTo(displayRibbon(), requestMenu(defaultOption, request)); 
                }}
                />,
            
        },
        'incoming-requests': {
            label: 'My Signature Requests',
            content: (gui) => <IncommingSignature seeAll={() => {
                gui.goTo(displayRibbon(), requestMenu());     
                }}
                loadData={async () => loadIncommingRequestsDashboard()}
                action={(request) => {
                    let defaultOption = "read"; 
                    gui.goTo(displayRibbon(), requestMenu(defaultOption, request)); 
                }}
                />
        }
    }
}

const requestMenu = (defaultOption, request, defaultFilter) => {
    return {
        "requests": {
            submenu: {
                "actions": {
                    options: {
                        new: {label: "New", do: (gui) => displayNewSignatureRequestForm(gui, () => { 
                            displaySignatureRequestList(gui)
                            setNewContext(gui);
                        })},
                    },
                    label: "Actions"
                }
            },
            label: "Signature Requests",
            do: (gui) => {
                if (defaultOption === "new") {
                    displayNewSignatureRequestForm(gui, () => { 
                        displaySignatureRequestList(gui)
                        setNewContext(gui);
                    });
                    defaultOption = undefined;
                } else if (defaultOption === "read") {
                    gui.goTo(displayReadSignatureRequestForm(gui, () => {
                        displaySignatureRequestList(gui)
                        setNewContext(gui);
                    }), request.id);
                    if (request.status === STATUS_PENDING)
                        setPendingContext(gui, () => { 
                            displaySignatureRequestList(gui)
                            setNewContext(gui);
                        });
                    else
                        setCompletedContext(gui, () => { 
                            displaySignatureRequestList(gui)
                            setNewContext(gui);
                        });
                    defaultOption = undefined;
                } else {
                    displaySignatureRequestList(gui, defaultFilter);
                    setNewContext(gui);
                }

            }
        },
    }
}